import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function passwordResetReducer(
  state = initialState.passwordReset,
  action
) {
  switch (action.type) {
    case types.RESET_PASSWORD_SUCCESS:
      return action.passwordReset;
    default:
      return state;
  }
}
